/**
 * Created by Administrador on 24/10/2019.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('customerCorporateReportCtrl', customerCorporateReportCtrl)
        .controller('customerCorporateOwnOperationsReportCtrl', customerCorporateOwnOperationsReportCtrl)
        .controller('customerCorporateReportKardexCtrl', customerCorporateReportKardexCtrl);

    customerCorporateReportCtrl.$inject = ['tabs','parents','userSession','datePickerService',
         'linkService', 'dateService', 'customerCorporateReportService',
         'excelService','userService'];

    customerCorporateOwnOperationsReportCtrl.$inject = ['tabs','userSession','datePickerService', 'linkService',
        'dateService', 'customerCorporateReportService', 'excelService','userService'];

    customerCorporateReportKardexCtrl.$inject = ['tabs','parents','userSession','datePickerService',
        'linkService', 'dateService', 'customerCorporateReportService',
        'excelService','userService','printService'];

    function customerCorporateReportCtrl(tabs,parents,userSession, datePickerService,
                                         linkService, dateService, customerCorporateReportService,
                                          excelService,userService){
        var vm = this;
        vm.isOwnOperations = false;
        vm.parents = parents;
        vm.tabs = tabs;
        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.userSession = userSession.data;


        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 30));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterCustomerCorporate.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };


        vm.filterCustomerCorporate = {
            currency: null,
            region: null,
            branchOffice: null,
            user: null,
            detail: true,
            fromDate: null,
            toDate: null
        };

        vm.disabledUserBranch = false;
        vm.isBranch = false;
        vm.isReport = false;
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(vm.userSession.positionType);
        vm.isDownload = false;
        vm.reportTransactionPassengerHtml = '';
        vm.toDate = null;
        vm.type = '';

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.generateOperations = function (isValid, form) {
            if(isValid){
                vm.transaction = {};
                vm.transaction.fromDate = dateService.dateTimeString(vm.filterCustomerCorporate.fromDate, 1);
                vm.transaction.toDate = dateService.dateTimeString(vm.filterCustomerCorporate.toDate, 2);
                vm.transaction.corporateParentId = linkService.getLinkId(vm.filterCustomerCorporate.parent._links.self.href);

                customerCorporateReportService.getCustomerCorporateOperations(vm.transaction).then(function (response) {
                    if(response !== undefined) {
                        vm.report = response.data;
                        if(vm.report.corporateCargoGroups.length>0){
                            vm.isReport = true;
                        }else{
                            vm.isReport = false;
                        }
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, 'report_customer_corporate_operations');
        }

        vm.cancelGenerate = function() {
            vm.filterCustomerCorporate.currency = null;
            vm.isReport = false;
        };

        vm.exportPdf = function(){
            vm.transaction = {};
            vm.transaction.fromDate = dateService.dateTimeString(vm.filterCustomerCorporate.fromDate, 1);
            vm.transaction.toDate = dateService.dateTimeString(vm.filterCustomerCorporate.toDate, 2);
            vm.transaction.corporateParentId = linkService.getLinkId(vm.filterCustomerCorporate.parent._links.self.href);
            customerCorporateReportService.getCustomerCorporateOperationsPdf(vm.transaction)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "operationes_clientes_coporativos.pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }

        vm.onChangeParents = function(){
            vm.filterCustomerCorporate.currency = null;
            vm.isReport = false;
        }
    }

    function customerCorporateOwnOperationsReportCtrl(tabs,userSession, datePickerService, linkService, dateService,
                                                      customerCorporateReportService, excelService,userService){
        var vm = this;
        vm.isOwnOperations = true;
        vm.tabs = tabs;
        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.userSession = userSession.data;


        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 30));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterCustomerCorporate.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };


        vm.filterCustomerCorporate = {
            fromDate: null,
            toDate: null
        };

        vm.disabledUserBranch = false;
        vm.isBranch = false;
        vm.isReport = false;
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(vm.userSession.positionType);
        vm.isDownload = false;
        vm.reportTransactionPassengerHtml = '';
        vm.toDate = null;
        vm.type = '';

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.generateOperations = function (isValid, form) {
            if(isValid){
                vm.transaction = {};
                vm.transaction.fromDate = dateService.dateTimeString(vm.filterCustomerCorporate.fromDate, 1);
                vm.transaction.toDate = dateService.dateTimeString(vm.filterCustomerCorporate.toDate, 2);

                customerCorporateReportService.getCustomerCorporateOwnOperations(vm.transaction).then(function (response) {
                    if(response !== undefined) {
                        vm.report = response.data;
                        if(vm.report.corporateCargoGroups.length>0){
                            vm.isReport = true;
                        }else{
                            vm.isReport = false;
                        }
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, 'report_customer_corporate_operations');
        }

        vm.cancelGenerate = function() {
            vm.isReport = false;
        };

        vm.exportPdf = function(){
            vm.transaction = {};
            vm.transaction.fromDate = dateService.dateTimeString(vm.filterCustomerCorporate.fromDate, 1);
            vm.transaction.toDate = dateService.dateTimeString(vm.filterCustomerCorporate.toDate, 2);
            customerCorporateReportService.getCustomerCorporateOwnOperationsPdf(vm.transaction)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "operationes_propias.pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }

        vm.onChangeParents = function(){
            vm.filterCustomerCorporate.currency = null;
            vm.isReport = false;
        }
    }

    function customerCorporateReportKardexCtrl(tabs,parents,userSession, datePickerService,
                                         linkService, dateService, customerCorporateReportService,
                                         excelService,userService,printService){
        var vm = this;
        vm.isOwnOperations = false;
        vm.parents = parents;
        vm.tabs = tabs;
        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.userSession = userSession.data;


        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 30));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterCustomerCorporate.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };


        vm.filterCustomerCorporate = {
            currency: null,
            region: null,
            branchOffice: null,
            user: null,
            detail: true,
            fromDate: null,
            toDate: null
        };

        vm.disabledUserBranch = false;
        vm.isBranch = false;
        vm.isReport = false;
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(vm.userSession.positionType);
        vm.isDownload = false;
        vm.reportTransactionPassengerHtml = '';
        vm.toDate = null;
        vm.type = '';

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.generate = function (isValid, form) {
            if(isValid){
                vm.information = {};
                vm.information.fromDate = dateService.dateTimeString(vm.filterCustomerCorporate.fromDate, 1);
                vm.information.toDate = dateService.dateTimeString(vm.filterCustomerCorporate.toDate, 2);
                vm.information.customerCorporateId = linkService.getLinkId(vm.filterCustomerCorporate.parent._links.self.href);
                vm.information.customerCorporateName = vm.filterCustomerCorporate.parent.socialReason;

                customerCorporateReportService.getCustomerCorporateReportKardex(vm.information).then(function (response) {
                    if(response !== undefined) {
                        if(response.data.length>0){
                            vm.report = response.data;
                            vm.isReport = true;
                        }else{
                            vm.report = "Sin Informacion"
                            vm.isReport = true;
                        }
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, 'report_customer_corporate_kardex');
        }

        vm.cancelGenerate = function() {
            vm.filterCustomerCorporate.currency = null;
            vm.isReport = false;
        };

        vm.generatePdfHtml = function (target) {
            printService.printPdfHtml(target);
        };

        vm.onChangeParents = function(){
            vm.filterCustomerCorporate.currency = null;
            vm.isReport = false;
        }
    }
})();
